import React, { Fragment } from "react";

import { useMediaQuery } from "react-responsive";
import { Route, Routes } from "react-router-dom";
import styled from "styled-components/macro";

import { Breadcrumbs } from "./components/Breadcrumbs/Breadcrumbs";
import { Footer } from "./components/Footer/Footer";
import { FooterMobile } from "./components/FooterMobile/FooterMobile";
import { Header } from "./components/Header/Header";
import { useIsNotFoundPage } from "./hooks/useNotFoundPage";
import { useScrollToTop } from "./hooks/useScrollToTop";
import { AboutCompany } from "./pages/AboutCompany/AboutCompany";
import { Blog } from "./pages/Blog/Blog";
import { Consent } from "./pages/Consent/Consent";
import { Main } from "./pages/Main/Main";
import { NotFound } from "./pages/NotFound/NotFound";
import { NotificationConsent } from "./pages/NotificationConsent/NotificationConsent";
import { Policy } from "./pages/Policy/Policy";
import { PostDetails } from "./pages/PostDetail/PostDetail";
import { Reviews } from "./pages/Reviews/Reviews";
import { Services } from "./pages/Services/Services";
import { CareerConsult } from "./pages/ServicesPages/CareerConsult"
import { CVReady } from "./pages/ServicesPages/CVReady";
import { ITHiring } from "./pages/ServicesPages/ITHiring";
import { ITTraining } from "./pages/ServicesPages/ITTraining";
import { LinkedinBoost } from "./pages/ServicesPages/LinkedinBoost";
import { ProbationSupport } from "./pages/ServicesPages/ProbationSupport";
import { SearchSupport } from "./pages/ServicesPages/SearchSupport";
import { Talkitout } from "./pages/ServicesPages/Talkitout";
import { Vacancies } from "./pages/ServicesPages/Vacancies";

const AppWrapper = styled.main`
  max-width: 1320px;
  margin: 0 auto;
  padding-top: 100px;

  @media (max-width: 1439px) {
    margin: 12px;
    max-width: none;
  }

  @media (max-width: 979px) {
    padding-top: 0;
  }

  @media (max-width: 979px) {
    margin: 12px 0 0;
  }
`

function App() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isNotFoundPage = useIsNotFoundPage();

  useScrollToTop()

  return (
    <Fragment>
      <Header />
      <AppWrapper>
        {!isNotFoundPage && <Breadcrumbs />}
        <Routes>
          <Route path="/blog/:id" element={<PostDetails />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Main />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/consent" element={<Consent />} />
          <Route path="/notification-consent" element={<NotificationConsent />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/talkitout" element={<Talkitout />} />
          <Route path="/services/career-consult" element={<CareerConsult />} />
          <Route path="/services/cv-ready" element={<CVReady />} />
          <Route path="/services/vacancies" element={<Vacancies />} />
          <Route path="/services/search-support" element={<SearchSupport />} />
          <Route path="/services/probation-support" element={<ProbationSupport />} />
          <Route path="/services/linkedin-boost" element={<LinkedinBoost />} />
          <Route path="/services/it-hiring" element={<ITHiring />} />
          <Route path="/services/it-training" element={<ITTraining />}/>
          <Route path="/blog" element={<Blog />} />
          <Route path="/company" element={<AboutCompany />} />
        </Routes>
      </AppWrapper>
      {!isNotFoundPage && (isMobile ? <FooterMobile /> : <Footer />)}
    </Fragment>
  );
}

export default App;
